import React from "react";
import { Link } from "react-router-dom";
import "../../../css/AreaGobierno/tribunal-de-cuentas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScale, faPaperclip } from "@fortawesome/free-solid-svg-icons";

const TribunalDeCuenta = () => (
  <div className="container my-5">
    <h2
      className="text-center"
      style={{ color: "#137158", fontWeight: "bold", marginBottom: "2rem" }}
    >
      TRIBUNAL DE CUENTAS
    </h2>

    <h4 className="text-center mb-4" style={{ color: "#333" }}>
      Conocé cada una de las áreas que conforman el Gobierno de la Ciudad de
      Oliva.
    </h4>

    <div
      className="tribunal-de-cuentas text-center"
      style={{ width: "60%", margin: "auto" }}
    >
      <a
        href={require("../../img/tribunal-de-cuenta.jpeg")}
        target="_blank"
        rel="noopener noreferrer"
        title="Tribunal de Cuenta"
        className="fancybox"
      >
        <img
          src={require("../../img/tribunal-de-cuenta.jpeg")}
          alt="Tribunal de Cuenta"
          className="img-fluid"
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(44,62,80,0.10)",
            maxWidth: "100%",
            marginBottom: "1.5rem",
          }}
        />
      </a>
    </div>

    <div className="row justify-content-center mt-5">
      <div className="col-md-4 col-12 mb-4 d-flex flex-column align-items-center">
        <a
          href="/tribunal-de-cuentas/memorias-tribunales"
          className="memoria-btn w-100 d-flex flex-column align-items-center justify-content-center"
        >
          <span className="memoria-btn-text text-center">
            <FontAwesomeIcon icon={faPaperclip} />
            MEMORIAS
          </span>
        </a>
      </div>
      <div className="col-md-4 col-12 mb-4 d-flex flex-column align-items-center">
        <a
          href="/tribunal-de-cuentas/resoluciones-tribunal-de-cuenta"
          className="memoria-btn w-100 d-flex flex-column align-items-center justify-content-center"
        >
          <span className="memoria-btn-text text-center">
            <FontAwesomeIcon icon={faBalanceScale} />
            RESOLUCIONES
          </span>
        </a>
      </div>
    </div>
  </div>
);

export default TribunalDeCuenta;
